// Libraries
import { CloseIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Text } from '@chakra-ui/react';
import { Fragment } from 'react';
// Components
import { MailtoText } from '@atoms/index';
import { InformationList } from '../InformationList';
// Utils
import text from '@translations/en.json';
// Types
import { UnknownModalProps } from './UnknownModal.types';

/**
 * UnknownModal component represents a modal for unknown errors.
 *
 * @component
 * @param {UnknownModalProps} props - The component props.
 * @param {Function} props.closeModal - The function to close the modal.
 * @param {string} [props.errorMessage] - The main error messages to show the user.
 * @param {Object} [props.errorDetail] - The object with the details of the error.
 * @returns {ReactElement} The UnknownModal component.
 */
export const UnknownModal = ({ closeModal, errorMessage, errorDetail, hideInternalCode = false}: UnknownModalProps) => {
  // TODO: Send the error object to sentry
  const internalErrorCode = hideInternalCode ? '' : `${text.error_id}: ${errorDetail.id} -`;
  return (
    <Fragment>
      <IconButton
        position='absolute'
        top={2.5}
        right={2.5}
        h={8}
        minW={8}
        aria-label={text.close_menu}
        variant='baseLight'
        icon={<CloseIcon color='text.faded' />}
        onClick={closeModal}
      />
      <Flex minH={8} align='center'>
        <Text fontSize='m' color='text.base' fontWeight='medium'>
          {text.schedule_modal_unknown_error_title}
        </Text>
      </Flex>
      <InformationList errors={[`${internalErrorCode} ${errorMessage}`]} warnings={[]} />
      <MailtoText
        fontSize='m'
        lineHeight='base'
        color='text.base'
        fontWeight='medium'
        email='support@bearing.ai'
        error={errorDetail.id}
      />
    </Fragment>
  );
};
